const es = {
  nav: {
    home: 'Inicio',
    suites: 'Suites',
    history: 'Historia',
    experiences: 'Experiencias',
    gallery: 'Galería',
    contact: 'Contacto',
    reserveNow: 'Reservar Ahora'
  },
  home: {
    heroTitle: 'Historia Viva',
    heroSubtitle: 'en Ouro Preto',
    checkInOut: 'Check-in / Out',
    checkInPlaceholder: 'Ej: 10/05 a 15/05',
    guests: 'Huéspedes',
    promoCode: 'Cód. Promo',
    promoPlaceholder: 'Opcional',
    search: 'Buscar',
    privilegedLocation: 'Ubicación Privilegiada',
    privilegedLocationDesc: 'En el corazón histórico de Ouro Preto, cerca de los principales puntos turísticos',
    exceptionalService: 'Servicio Excepcional',
    exceptionalServiceDesc: 'Equipo dedicado para hacer su estadía inolvidable',
    luxuryHistory: 'Lujo e Historia',
    luxuryHistoryDesc: 'Decoración que une el encanto colonial con comodidad moderna',
    ourAccommodations: 'Nuestros Alojamientos',
    ourAccommodationsDesc: 'Elija entre nuestras suites cuidadosamente decoradas, cada una ofreciendo una experiencia única',
    viewAllSuites: 'Ver Todas las Suites',
    readyToLiveHistory: '¿Listo para Vivir Historia?',
    readyToLiveHistoryDesc: 'Reserve ahora y asegure su experiencia inolvidable en Ouro Preto',
    person: 'Persona',
    people: 'Personas',
    morePeople: '+ Personas'
  },
  suites: {
    title: 'Nuestras Suites',
    description: 'Cada suite ha sido cuidadosamente diseñada para ofrecer el máximo confort y una experiencia única, combinando el encanto histórico de Ouro Preto con comodidades modernas.',
    size: 'Tamaño',
    capacity: 'Capacidad',
    daily: 'Tarifa',
    viewDetails: 'Ver Detalles',
    needHelp: '¿Necesita Ayuda para Elegir?',
    needHelpDesc: 'Nuestro equipo está listo para ayudarle a encontrar la suite perfecta para su estadía.',
    talkOnWhatsApp: 'Hablar por WhatsApp',
    standard: {
      name: 'Habitación Standard',
      subtitle: 'Confort y Elegancia',
      description: 'Nuestra Habitación Standard ofrece una experiencia acogedora con decoración que combina el encanto colonial de Ouro Preto con comodidad moderna. Ideal para parejas o viajeros solitarios que buscan una estadía confortable.',
      amenities: [
        'Cama de matrimonio cómoda',
        'TV LED con canales de cable',
        'WiFi de alta velocidad',
        'Minibar',
        'Baño privado con ducha caliente',
        'Caja fuerte',
        'Desayuno incluido'
      ]
    },
    junior: {
      name: 'Suite Junior',
      subtitle: 'Espacio y Sofisticación',
      description: 'La Suite Junior es perfecta para quienes buscan más espacio y confort. Con área amplia y decoración refinada, ofrece un ambiente relajante con toques de lujo que remiten a la historia de Ouro Preto.',
      amenities: [
        'Cama king-size premium',
        'Zona de estar cómoda',
        'Smart TV 32"',
        'WiFi',
        'Minibar',
        'Caja fuerte',
        'Baño espacioso',
        'Balcón privado',
        'Desayuno incluido'
      ]
    },
    executiva: {
      name: 'Suite Ejecutiva',
      subtitle: 'Refinamiento y Exclusividad',
      description: 'Nuestra Suite Ejecutiva está diseñada para viajeros exigentes que valoran el confort premium y servicios diferenciados. Con vista privilegiada y decoración elegante, es ideal para estadías prolongadas.',
      amenities: [
        'Cama king-size premium',
        'TV 32"',
        'WiFi ultrarrápido',
        'Caja fuerte digital',
        'Balcón amplio con vista',
        'Desayuno incluido',
        'Baño de lujo',
        'Servicio de habitación',
        'Muebles coloniales'
      ]
    },
    master: {
      name: 'Suite Master',
      subtitle: 'El Máximo en Lujo',
      description: 'La Suite Master es nuestro alojamiento más lujoso y exclusivo. Con diseño sofisticado, espacio generoso y todas las comodidades imaginables, proporciona una experiencia inolvidable en el corazón de Ouro Preto.',
      amenities: [
        'Dormitorio principal con cama king-size',
        'TV 32" con Sky',
        'WiFi de alta velocidad',
        'Caja fuerte',
        'Baño master',
        'Balcón panorámico',
        'Servicio de habitación dedicado',
        'Desayuno incluido',
        'Muebles coloniales'
      ]
    },
    backToSuites: 'Volver a Suites',
    startingFrom: 'Desde',
    perNight: 'por noche',
    aboutSuite: 'Sobre la Suite',
    amenities: 'Comodidades',
    reserveThisSuite: 'Reservar Esta Suite',
    accommodation: 'Alojamiento',
    luxury: 'Lujo'
  },
  history: {
    title: 'Nuestra Historia',
    quote: '"En el corazón histórico de Ouro Preto, donde cada piedra cuenta una historia, la Pousada do Mondego nace como un tributo a la rica herencia colonial brasileña."',
    journeyTitle: 'Un Viaje a Través del Tiempo',
    journeyText1: 'Ubicada en el icónico Largo de Coimbra, la Pousada do Mondego ocupa un edificio que se remonta al siglo XVIII, período áureo del ciclo del oro en Minas Gerais. Originalmente construida como residencia de una familia portuguesa, la construcción preserva elementos arquitectónicos típicos del barroco colonial.',
    journeyText2: 'En 2016, después de una cuidadosa restauración que tomó tres años, el edificio fue transformado en una posada boutique, manteniendo su esencia histórica mientras incorporaba todas las comodidades modernas que nuestros huéspedes merecen.',
    preservationTitle: 'Preservación con Pasión',
    preservationText1: 'Cada detalle de la Pousada do Mondego fue pensado para honrar la historia de Ouro Preto. Las paredes de piedra original fueron preservadas, las puertas y ventanas de madera maciza fueron restauradas artesanalmente, y elementos decorativos coloniales fueron integrados a la decoración contemporánea.',
    preservationText2: 'La posada se dedica íntegramente a la preservación del patrimonio histórico, guiada por un profundo compromiso con la conservación de nuestra herencia cultural y el respeto a la memoria brasileña.',
    familyTitle: 'La Familia Mondego',
    familyText1: 'El nombre "Mondego" es un homenaje al Río Mondego, que atraviesa la ciudad de Coimbra en Portugal, de donde vinieron los primeros propietarios del edificio en el siglo XVIII. Esta conexión luso-brasileña se celebra en cada rincón de la posada.',
    familyText2: 'Hoy, la Pousada do Mondego es administrada por una familia, que durante tres generaciones se ha dedicado a la hospitalidad en Minas Gerais. Con amor y dedicación, continuamos escribiendo nuevos capítulos de esta historia centenaria.',
    timeline: 'Línea de Tiempo',
    timeline1747: 'Construcción del edificio original como residencia colonial',
    timeline1980: 'Inicio del cuidadoso proyecto de restauración por la familia Pereira',
    timeline1988: 'Inauguración de la Pousada do Mondego',
    timeline2012: 'Inicio del proceso de restauración y adaptación',
    timeline2016: 'Reinauguración de la Pousada do Mondego'
  },
  experiences: {
    title: 'Experiencias',
    subtitle: 'Descubra lo mejor de Ouro Preto',
    toursActivities: 'Eventos',
    toursDesc: 'Nuestro equipo de concierge puede organizar experiencias únicas para hacer su estadía inolvidable',
    historicalTours: 'Paseos Históricos',
    adventureNature: 'Aventura y Naturaleza',
    cultureGastronomy: 'Cultura y Gastronomía',
    photography: 'Fotografía',
    events: 'Eventos',
    weddings: 'Bodas',
    weddingsDesc: 'Haz realidad el sueño de celebrar en un lugar inolvidable.',
    corporateEvents: 'Eventos Corporativos',
    corporateEventsDesc: 'Trae a tu equipo a un paisaje impresionante.',
    customized: 'Personalizado',
    onRequest: 'Bajo consulta',
    annualEvents: 'Eventos Anuales',
    annualEventsDesc: 'Ouro Preto es escenario de eventos culturales durante todo el año',
    customizeExperience: 'Personalice Su Experiencia',
    customizeDesc: 'Contacte con nuestro equipo de concierge para crear un itinerario personalizado.',
    talkToConcierge: 'Hablar con Concierge',
    duration: 'Duración',
    price: 'Precio',
    annualEventsList: {
      anniversary: { name: 'Aniversario de Ouro Preto', month: '08 de Julio', description: 'Feriado municipal.' },
      gastronomicFestival: { name: 'Festival Gastronómico', month: 'Julio', description: 'Celebración de la gastronomía de Minas Gerais con menús especiales en restaurantes locales.' },
      corpusChristi: { name: 'Corpus Christi', month: 'Mayo/Junio', description: 'Feriado nacional.' },
      holyWeek: { name: 'Semana Santa', month: 'Marzo/Abril', description: 'Celebraciones religiosas tradicionales con procesiones y alfombras de flores en las calles.' },
      tiradentes: { name: 'Tiradentes', month: '21 de Abril', description: 'Feriado nacional, fecha magna vinculada a la Conjura de Minas Gerais.' },
      laborDay: { name: 'Día del Trabajador', month: '01 de Mayo', description: 'Feriado nacional.' },
      independence: { name: 'Independencia de Brasil', month: '07 de Septiembre', description: 'Feriado nacional.' },
      aparecida: { name: 'Nuestra Señora Aparecida', month: '12 de Octubre', description: 'Feriado nacional y fiesta en las repúblicas de Ouro Preto.' },
      finados: { name: 'Día de los Difuntos', month: '02 de Noviembre', description: 'Feriado nacional.' },
      republicProclamation: { name: 'Proclamación de la República', month: '15 de Noviembre', description: 'Feriado nacional.' },
      blackConsciousness: { name: 'Día Nacional de Zumbi y de la Conciencia Negra', month: '20 de Noviembre', description: 'Feriado nacional.' }
    }
  },
  gallery: {
    title: 'Galería',
    description: 'Explore la belleza y el confort de la Pousada do Mondego a través de nuestra galería de imágenes',
    categories: {
      facade: 'Fachada y Exterior',
      diner:'Cena Especial', 
      standard: 'Habitación Standard',
      junior: 'Suite Junior',
      executive: 'Suite Ejecutiva',
      master: 'Suite Master',
      common: 'Áreas Comunes',
      details: 'Detalles',
      media: 'Mondego en los Medios',
      breakfast: 'Desayuno'
    }
  },
  contact: {
    title: 'Contacto',
    subtitle: 'Estamos aquí para ayudarle',
    getInTouch: 'Póngase en Contacto',
    getInTouchDesc: 'Nuestro equipo está listo para atenderle y hacer su experiencia en la Pousada do Mondego inolvidable.',
    address: 'Dirección',
    phone: 'Teléfono',
    whatsappContact: 'WhatsApp',
    whatsappAvailable: 'WhatsApp disponible',
    email: 'Email',
    serviceHours: 'Horario de Atención',
    mondayToFriday: 'Lunes a Viernes',
    saturday: 'Sábado',
    sundaysHolidays: 'Domingos y Festivos',
    closed: 'Cerrado',
    socialMedia: 'Redes Sociales',
    sendMessage: 'Enviar un Mensaje',
    fullName: 'Nombre Completo',
    yourName: 'Su nombre',
    yourEmail: 'su@email.com',
    message: 'Mensaje',
    howCanWeHelp: '¿Cómo podemos ayudarle?',
    sendButton: 'Enviar Mensaje',
    messageSent: '¡Mensaje Enviado!',
    willReturnSoon: 'Responderemos pronto.',
    ourLocation: 'Nuestra Ubicación',
    checkIn: 'Check-in: 14h',
    checkOut: 'Check-out: 12h',
    breakfastIncluded: 'Desayuno incluido',
    freeWifi: 'WiFi gratuito',
    freeParking: 'Aparcamiento gratuito'
  },
  cookies: {
    title: 'Cookies',
    text: 'Usamos cookies para entender cómo se usa el sitio y mejorar su experiencia. Puede aceptar o rechazar.',
    accept: 'Aceptar',
    refuse: 'Rechazar',
    settings: 'Preferencias de cookies'
  },
  footer: {
    description: 'Una experiencia única de alojamiento en el corazón histórico de Ouro Preto.',
    quickLinks: 'Enlaces Rápidos',
    information: 'Información',
    copyright: 'Todos los derechos reservados.'
  },
  whatsapp: {
    hello: '¡Hola! 👋 Me gustaría solicitar un presupuesto para *Pousada do Mondego*:',
    period: '📅 *Período:*',
    guests: '👥 *Cantidad de Huéspedes:*',
    code: '🎟️ *Código:*',
    checkAvailability: '¿Podrían verificar la disponibilidad, por favor?',
    reserveSuite: '¡Hola! 👋 Me gustaría hacer una reserva de la *{suite}*. ¿Podrían enviarme más información?',
    helpChoosing: '¡Hola! Me gustaría ayuda para elegir una suite.',
    experiencesInfo: '¡Hola! Me gustaría información sobre paseos y experiencias.',
    newMessage: '*Nuevo Mensaje del Sitio Web*',
    name: '*Nombre:*',
    phone: '*Teléfono:*',
    toArrange: 'A convenir'
  }
};

export default es;
